import angular from 'angular';
import { isGuid } from '@/shared/utils/guid';

angular.module('cloudX').directive('cxRelationFreeTextInput', [
  '$http',
  'appUrls',
  '$timeout',
  'relationNameFilter',
  'dialogsSvc',
  function($http, appUrls, $timeout, relationNameFilter, dialogsSvc) {
    return {
      restrict: 'E',
      require: '^ngModel',
      replace: true,

      scope: {
        id: '@',
        searchOptions: '=?',
        placeholder: '@',
        createBtn: '@',
      },
      template: `<div class="input-group">
          <input type="text"
                 ng-model="text"
                 id="{{id}}-Text"
                 ng-change="onChange()"
                 class="form-control"
                 autocomplete="off"
                 placeholder="{{placeholder}}"
                 ng-hide="showSearch"
                 cx-focus-this="focusOn==='text'"
          />
          <input type="text"
                 ng-disabled="disabled"
                 id="{{id}}-Relation"
                 ng-model="value"
                 uib-search-relation
                 typeahead-on-select="selectRelation($item)"
                 ng-blur="handleBlur()"
                 ng-focus="ddwOpen=false"
                 class="form-control"
                 placeholder="{{('Search relation' | translate)}}"
                 ng-model-options="{updateOn: 'default blur', debounce: { 'default': 400, 'blur': 0 }}"
                 search-options="searchOptions"
                 ng-show="showSearch"
                 cx-focus-this="focusOn==='rel'"
                 autocomplete="off"/>

          <span class="input-group-btn">
            <button class="btn btn-default btn-font-14"
                    id="{{id}}-ClearBtn"
                    ng-show="hasValue()"
                    ng-click="clear()">
              <i class="fa fa-times"></i>
            </button>
            <button class="btn btn-default btn-font-14"
                    id="{{id}}-ToggleBtn"
                    ng-click="toggleState()"
                    ng-show="!hasValue()"
                    title="{{ 'Free input' | translate }}">
              <i class="fa fa-search" ng-hide="showSearch"></i>
              <i class="fa fa-keyboard-o" ng-show="showSearch"></i>
            </button>
            <button class="btn btn-default btn-font-14"
                    id="{{id}}-CreateRelationBtn"
                    ng-show="!hasValue() && !!createBtn"
                    cx-security="'Relation:c'"
                    ng-click="openNewRelationDialog()"
                    title="{{ 'New relation' | translate }}">
              <i class="fa fa-plus"></i>
            </button>
          </span>
        </div>`,
      link: function(scope, element, attrs, ngModel) {
        if (!ngModel) return;
        scope.value = null;
        scope.text = null;
        scope.relation = null;
        scope.showSearch = false;
        scope.focusOn = '';

        scope.onChange = function() {
          if (scope.showSearch) {
            if (scope.relation && scope.relation.id) {
              ngModel.$setViewValue({
                text: null,
                relation: scope.relation,
              });
            } else {
              ngModel.$setViewValue({
                text: null,
                relation: null,
              });
            }
          } else {
            ngModel.$setViewValue({
              text: scope.text || null,
              relation: null,
            });
          }
        };
        scope.selectRelation = function(relation) {
          if (!relation || !relation.id) {
            scope.relation = null;
            scope.text = null;
            scope.onChange();
          } else {
            scope.relation = relation;
            scope.text = null;
            scope.onChange();
          }
        };
        scope.clear = function() {
          scope.value = null;
          scope.text = null;
          scope.relation = null;
          scope.onChange();
        };
        scope.handleBlur = function() {
          $timeout(function() {
            if (scope.showSearch && scope.value && !scope.value.id) {
              scope.clear(); //Clear value on blur
            }
          }, 500);
        };
        scope.toggleState = function() {
          //Reset input
          scope.clear();
          scope.showSearch = !scope.showSearch;
          scope.focusOn = scope.showSearch ? 'rel' : 'text';
        };
        scope.hasValue = function() {
          if (scope.showSearch) {
            return !!scope.relation?.id;
          }
          return !!scope.text;
        };
        scope.openNewRelationDialog = function() {
          dialogsSvc
            .showRelationWizard('newRelation', {
              relType: 2,
              crmType: 0,
            })
            .then(function(result) {
              if (result && result.relation && result.relation.id) {
                scope.relation = result.relation;
                scope.value = relationNameFilter(result.relation);
                scope.text = null;
                scope.showSearch = true;
                scope.onChange();
              }
            });
        };

        const initByRelationById = id => {
          return $http.post(`${appUrls.api}/api/relation/names`, [id]).then(
            ({ data = null }) => {
              if (data) {
                const [relation] = data;
                if (relation) {
                  scope.relation = relation;
                  scope.value = relationNameFilter(relation);
                  scope.showSearch = true;
                  return relation;
                }
              }
              scope.relation = null;
              scope.value = null;
              scope.text = null;
              scope.showSearch = true;
            },
            () => {
              scope.relation = null;
              scope.value = null;
              scope.text = null;
              scope.showSearch = true;
            },
          );
        };

        ngModel.$render = function() {
          const value = ngModel.$viewValue;
          if (!value || typeof value !== 'object') {
            scope.relation = null;
            scope.value = null;
            scope.text = null;
            scope.showSearch = true;
            return;
          }
          if (!!value.relation) {
            if (typeof value.relation === 'string' && isGuid(value.relation)) {
              // { relation:'relationId',text:null }
              initByRelationById(value.relation);
              return;
            }

            if (!value.relation.id) {
              // { relation:'randomText',text:null }
              scope.relation = null;
              scope.value = null;
              scope.showSearch = false;
            } else if (!value.relation.name) {
              // { relation:{id:'relationId', name:null },text:null }
              initByRelationById(value.id);
              return;
            } else {
              // { relation:{id:'relationId', name:'relationName' },text:null }
              scope.relation = value.relation;
              scope.value = relationNameFilter(value.relation);
              scope.text = null;
              scope.showSearch = true;
              return;
            }
          }

          // { relation:null,text:null }
          // { relation:null,text:'text' }
          scope.text = value.text || null;
          scope.relation = null;
          scope.value = null;
          scope.showSearch = !scope.text;
        };
      },
    };
  },
]);
